import React, { Fragment, Children, cloneElement } from 'react'
import cx from 'classnames'

import { WidthContainer } from 'components/_new/layout'

import s from './FloatButtonContainer.scss'


export type FloatButtonContainerProps = {
  className?: string
  withShadow?: boolean
  withPlaceholder?: boolean
  children: React.ReactElement
}

const FloatButtonContainer: React.FunctionComponent<FloatButtonContainerProps> = ({ children, className, withShadow = true, withPlaceholder = true }) => (
  <Fragment>
    <WidthContainer className={cx(s.container, className)}>
      {
        Children.map(children, (child: React.ReactElement) => Boolean(child) && (
          cloneElement(child, {
            className: cx(s.button, child.props.className, {
              [s.withShadow]: withShadow,
            }),
          })
        ))
      }
    </WidthContainer>
    {
      withPlaceholder && (
        <div className={s.placeholder} />
      )
    }
  </Fragment>
)


export default FloatButtonContainer
